import { BorrowAdminChangeInterestComponent } from "../../../components/borrowSystem/Contact/BorrowAdminChangeInterestComponent"
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function BorrowAdminChangeInterestContainer () {
    const titleName = "รายละเอียดอัตราดอกเบี้ย";
    return(
        <div className="page-container bg-landing">
            <NavbarBorrowSystem  />
            <HeadTitle title={titleName} />
            <BorrowAdminChangeInterestComponent/>
            <Footer />
        </div>   
    )
}